import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import LogoSvg from "../../images/logo-full.svg"
import styled from "styled-components"

const A = styled.a``

const Logo = styled(props => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  return (
    <A href={data.site.siteMetadata.siteUrl} {...props}>
      <img alt="Karbon" title="Karbon Logo" src={LogoSvg} />
    </A>
  )
})`
  display: flex;
  align-items: center;
  overflow: hidden;
  height: 42px;
  width: 169px;

  img {
    position: relative;
    top: 0;
    max-width: none;
    width: 169px;
    height: 42px;
  }
`

export default Logo
